/** Shared IITH public asset paths (served from frontend/public). */
export const IITH_LOGO_URL = '/assets/iith-logo.png';
